import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockProfilePictureFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const profilePictureBlockConfig = {
  name: 'inner-block-profile-picture',
  component: defineAsyncComponent(() => import('./CmsProfilePicture.vue')),
  innerComponent: defineAsyncComponent(() => import('@pkg/ui/components/base/ProfilePicture.vue')),
  fields: blockProfilePictureFields,
} satisfies ModularBlockConfig;
